'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from "universal-cookie";
import Modal from "react-bootstrap/Modal";
import {CartRow} from "./cart-row";

export {CartPopup};

const e = React.createElement;

class CartPopup extends React.Component {
    constructor(props) {
        super(props);
        this.state = { cart: this.props.cart, modalIsOpen: this.props.modalIsOpen };

    }


    updateState(result){
        this.setState({cart: result.data});
        //this.setState({compatible: result.data.compatible});
    }

    render() {
        let leftovers = tools.getLeftoversNotifications(this.props.cart.items);
        let quantities = tools.getQuantityNotifications(this.props.cart.items);
        let tradeins = tools.getTradeinNotifications(this.props.cart.items);
        return (
            <React.Fragment>
                <Modal show={this.props.modalIsOpen } onHide={this.props.closeModal} className={"side-modal right checkoutEdit"} dialogClassName={"modal-dialog"}>
                    <Modal.Header closeButton>
                        <Modal.Title>{this.props.title} <span className="basket-products-count">{this.props.cart.total_count} {tools.declOfNums(this.props.cart.total_count, lajax.t('товар,товара,товаров').split(','))}</span></Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className={"wrapper-cart" + (this.props.cart.notifications.filter((n) => n.text == 'zeroPriceProductExists').length || leftovers.length > 0  || true ? " wrapper-cart--e-state" : "")}>

                            <div className="custom-scroll">
                                <If condition={tradeins.length}>
                                    {tradeins.map((notification) => (
                                        <div className="checkout__delivery-msg checkout__delivery-msg_error">
                                            <h4>{lajax.t('Обратите внимание!')}</h4>
                                            <p>{notification}</p>
                                        </div>
                                    ))}
                                </If>
                                <If condition={quantities.length}>
                                    {quantities.map((notification) => (
                                        <div className="checkout__delivery-msg checkout__delivery-msg_error">
                                            <h4>{lajax.t('Обратите внимание!')}</h4>
                                            <p>{notification}</p>
                                        </div>
                                    ))}
                                </If>
                                <If condition={leftovers.length > 0}>
                                    {leftovers.map((notification) => (
                                        <div className="checkout__delivery-msg checkout__delivery-msg_error">
                                            <h4>{lajax.t('Обратите внимание!')}</h4>
                                            <p>{notification}</p>
                                        </div>
                                    ))}
                                </If>
                                {this.props.cart.items.map((item, i) => (
                                    <CartRow
                                        item={item}
                                        key={"cartrow" + i}
                                        onUpdate={this.props.onUpdate}
                                        handleDeleteProduct={this.props.handleDeleteProduct}
                                        assemblyProduct={false}
                                        list={this.props.list}
                                        position={i}
                                        bundle_id={0}
                                    />
                                ))}
                            </div>
                        </div>
                        <div className="bag-total">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-6">
                                    <If condition={this.props.cart.total_bonuses_to_charge}>
                                    <div className="bag-total__row">
                                        <div className="bag-total__label">{lajax.t('Начислено бонусов')}</div>
                                        <div className="bag-total__value">
                                            <div className="thanks-page__product-bonus">{this.props.cart.total_bonuses_to_charge ? '+' : ''}{tools.displayPrice(this.props.cart.total_bonuses_to_charge)}</div>
                                        </div>
                                    </div>
                                    </If>
                                    <div className="bag-total__row">
                                        <div className="bag-total__label">{lajax.t('Итого:')}</div>
                                        <div className="bag-total__value">
                                            <div className="thanks-page__kit-price">{tools.displayPrice(this.props.cart.total_price)} <span>₴</span></div>
                                        </div>
                                    </div>
                                </div>
                                <If condition={this.props.showTotal}>
                                <div className="col-12 col-md-6"><a className="btn btn-primary btn-md w-100" href={baseUrl + "order/"}>{lajax.t('Оформить заказ')}</a></div>
                                </If>
                                <If condition={!this.props.showTotal}>
                                    <div className="col-12 col-md-6"><button className="btn btn-primary btn-md w-100" onClick={this.props.closeModal}>{lajax.t('Продовжити оформлення')}</button></div>
                                </If>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </React.Fragment>

        );

    }
}


function addProduct(id_product, callback)
{
    const recipeUrl = baseUrl + 'assembly/add-product';
    const postBody = {
        id_product: id_product,
    };

    const requestMetadata = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(postBody)
    };

    fetch(recipeUrl, requestMetadata)
        .then(res => res.json())
        .then(res => {
            callback(res);

        });
}

function deleteProduct(id_product, callback)
{
    const recipeUrl = baseUrl + 'assembly/delete-product';
    const postBody = {
        id_product: id_product,
    };

    const requestMetadata = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(postBody)
    };

    fetch(recipeUrl, requestMetadata)
        .then(res => res.json())
        .then(res => {
            callback(res);
        });
}

function updateProductQuantity(id_product, quantity, callback)
{
    const recipeUrl = baseUrl + 'assembly/update-product-quantity';
    const postBody = {
        id_product: id_product,
        quantity: quantity,
    };

    const requestMetadata = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(postBody)
    };

    fetch(recipeUrl, requestMetadata)
        .then(res => res.json())
        .then(res => {
            callback(res);
        });
}

function cartPopup(cartProducts, show)
{
    const domContainer = document.querySelector('#cartPopup');
    ReactDOM.render(e(CartPopup, {
        products: cartProducts,
        show: show,
        //categoriesFilter: categoriesFilter,
        //categoriesFeature: categoriesFeature,
    }), domContainer);
}
